var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('ProductFilter',{attrs:{"products":_vm.filter.products}})],1),_c('v-col',[_c('NumberOfMonthsSelector',{attrs:{"months":_vm.filter.months}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }